import { Col, Row, TextInput } from 'ui';

export type MemberCommunitiesListFiltersFormValues = {
  search?: string;
};

const MemberCommunitiesListFilters = () => (
  <Row>
    <Col span={24}>
      <TextInput hasSearch item={{ label: 'Search', name: 'search' }} />
    </Col>
  </Row>
);

export default MemberCommunitiesListFilters;
